export function initSearchFilter() {
  const searchFilter = document.querySelector('.blog-search-filter')

  if (searchFilter) {
    searchFilter.onclick = () => {
      document.querySelector('.filter-menu').classList.toggle('js-active')
    }
  }
}
